import { useSelector } from 'react-redux';
import SingleDelivery from './SingleDelivery';
import _ from 'lodash';
import { useParameters } from '@web/utils/src';
import { useUserSilosAndAddresses } from '@/hooks/useUserSilosAndAddresses';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { OrderDeliveryInput } from '@/types';
import { CartDelivery, CartDeliveryAddress } from '@agrantis/cart';
import { updateCartDelivery } from '@agrantis/cart/actions/cart';
import {
  CalculatedCartItem,
  selectComputedCartByKey,
} from '@agrantis/cart/selectors';

export interface CheckoutDeliveryShipment extends OrderDeliveryInput {
  shipmentId: number;
  selectedAddressId: number | null;
}

const DeliveriesTable = () => {
  const { retailerId } = useParameters<{ retailerId: string }>();
  const cart = useSelector(selectComputedCartByKey(retailerId));
  const retailer = useAppSelector((state) => state.retailer.retailer);
  const dispatch = useAppDispatch();
  const cartKey = retailerId;
  const { silos, addresses, primaryAddress } = useUserSilosAndAddresses({
    retailerId,
  });

  const handleEditItem = (item: CalculatedCartItem, delivery: CartDelivery) => {
    // need to implement
  };

  const handleLocationChange = (locationId: number, deliveryId: string) => {
    dispatch(
      updateCartDelivery({
        cartKey,
        deliveryId,
        locationId,
        requiredDeliveryDate: retailer?.settings?.requiredDeliveryDate,
      }),
    );
  };

  const handleCommentChange = (comment: string, deliveryId: string) => {
    dispatch(
      updateCartDelivery({
        cartKey,
        deliveryId,
        comment,
        requiredDeliveryDate: retailer?.settings?.requiredDeliveryDate,
      }),
    );
  };

  const handleSiloChange = (siloId: number, deliveryId: string) => {
    const silo = _.find(silos, (i) => siloId === i.id);

    if (!silo) {
      return;
    }

    dispatch(
      updateCartDelivery({
        cartKey,
        deliveryId,
        siloId: silo.id,
        deliveryAddress: silo.address,
        requiredDeliveryDate: retailer?.settings?.requiredDeliveryDate,
      }),
    );
  };

  const handleFromTime = (deliveryFrom: string, deliveryId: string) => {
    dispatch(
      updateCartDelivery({
        cartKey,
        deliveryId,
        deliveryFrom,
        requiredDeliveryDate: retailer?.settings?.requiredDeliveryDate,
      }),
    );
  };

  const handleToTime = (deliveryTo: string, deliveryId: string) => {
    dispatch(
      updateCartDelivery({
        cartKey,
        deliveryId,
        deliveryTo,
        requiredDeliveryDate: retailer?.settings?.requiredDeliveryDate,
      }),
    );
  };

  const onAddressChange = (
    address: CartDeliveryAddress,
    deliveryId: string,
  ) => {
    dispatch(
      updateCartDelivery({
        cartKey: retailerId,
        deliveryId,
        deliveryAddress: address,
        requiredDeliveryDate: retailer?.settings?.requiredDeliveryDate,
      }),
    );
  };

  return (
    <>
      <p className="text-2-2 md:text-2-0 font-bd mb-1-6">Bestellübersicht</p>
      <div>
        {Object.values(cart?.deliveries || {}).map((delivery, index) => (
          <SingleDelivery
            onLocationChange={handleLocationChange}
            onCommentChange={handleCommentChange}
            onAddressChange={onAddressChange}
            primaryAddress={primaryAddress}
            onSiloChange={handleSiloChange}
            onFromTime={handleFromTime}
            onEditItem={handleEditItem}
            onToTime={handleToTime}
            addresses={addresses}
            delivery={delivery}
            key={index}
            index={index + 1}
            cartKey={cartKey}
            silos={silos}
          />
        ))}
      </div>
    </>
  );
};

export default DeliveriesTable;
